import { useQuery } from '@tanstack/react-query'
import { axiosClient } from 'api/apiClient'
import { type Address } from 'use-towns-client'
import { env } from 'utils/environment'
import { z } from 'zod'

const zBotMetadata = z.object({
    installCount: z.number().default(0),
    totalUsers: z.number().default(0),
})

const zBotMetadataResponse = z.object({
    success: z.boolean(),
    bots: z.array(zBotMetadata).default([]),
})

export type BotMetadataQueryData = z.infer<typeof zBotMetadata>

const defaultData: BotMetadataQueryData = { installCount: 0, totalUsers: 0 }

export const useBotMetadataQuery = (appAddress: Address | undefined) => {
    return useQuery({
        queryKey: ['bot-metadata', appAddress],
        queryFn: async (): Promise<BotMetadataQueryData> => {
            if (!appAddress) {
                return defaultData
            }

            const response = await axiosClient.get(
                `${env.VITE_GATEWAY_URL}/bots/${appAddress}/metadata`,
            )

            const parseResult = zBotMetadataResponse.safeParse(response.data)

            if (!parseResult.success || !parseResult.data.success) {
                return defaultData
            }

            return parseResult.data.bots[0] ?? defaultData
        },
        enabled: !!appAddress,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
    })
}
